import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import type { GroupsHubDataState } from '../../state/data/groupsHubDataState';
import prefetchReducer from './groupsHub/prefetchStateReducer';
import deleteGroupsReducer from './groupsHub/deletedGroupsReducer';
import joinedGroupsReducer from './groupsHub/joinedGroupsReducer';
import ownedGroupsReducer from './groupsHub/ownedGroupsReducer';
import unifiedGroupsReducer from './groupsHub/unifiedGroupsReducer';

const reducer: Reducer<GroupsHubDataState> = combineReducers<GroupsHubDataState>({
    deletedGroupsIds: deleteGroupsReducer,
    prefetchState: prefetchReducer,
    joinedGroupsIds: joinedGroupsReducer,
    ownedGroupsIds: ownedGroupsReducer,
    unifiedGroupsMap: unifiedGroupsReducer,
} as ReducersMapObject<GroupsHubDataState>);

export default reducer;
